import React from 'react';
import { Surface } from '@antonpodolsky/design-system/regions/surface/surface';
import { Stack } from '@antonpodolsky/design-system/layout/stack/stack';
import { Text } from '@antonpodolsky/design-system/typography/text/text';
import { Link } from '@antonpodolsky/design-system/typography/link/link';
import { CurrentYear } from '@antonpodolsky/design-system/typography/current-year/current-year';
import { AddonButtons } from '../addon/addon-buttons';

export const SiteFooter = () => (
  <Stack as="footer" gap="none">
    <Surface background="tint-2" paddingBlock="5xl">
      <Stack gap="3xl">
        <Text variant="label" centered>
          Get Exify for your browser
        </Text>
        <AddonButtons />
      </Stack>
    </Surface>

    <Surface background="inverse" paddingBlock="xl">
      <Text centered>
        &copy; <CurrentYear />,{' '}
        <Link href="https://www.antonpodolsky.com/" external>
          Anton Podolsky
        </Link>
        . All Rights Reserved.
      </Text>
    </Surface>
  </Stack>
);
